import React, { Component } from 'react';
import { Popover, Col, Modal, Icon, Button, Checkbox, Radio, Transfer, Select, Row, Input, Tree, Tag,TreeSelect,InputNumber, DatePicker,Tooltip } from 'antd';
import { Label, Refer } from '../basic';
import { proxy } from '../../helpers/util';
import DefinedLeftcontent from './definedLeftcontent';
import _ from 'lodash';
import moment from 'moment';
import Filterfooter from './filterfooter';
const format = "YYYY-MM-DD";
import SvgIcon from 'SvgIcon';
//运算符
class Operator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            operatordata: []
        }
    }
    componentDidMount() {
        this.getOperatorList()
    }
    //获取运算符数据
    async  getOperatorList() {
        const config = {
            url: 'enum/getEnumMap',
            method: 'GET',
            params: {
                enumtype: 'expressionType'
            }
        };
        const json = await proxy(config);
        if (json.code !== 200) return;
        json.data && this.setState({ operatordata: json.data })
    }
    //点击运算符按钮
    buttonClick(e, type) {
        if (type == 'search') {
            this.SearchEvent();
        }
        else {//
            let showMore = false;
            if (type == 'more') showMore = true;
            this.setState({
                showMore: showMore
            });
        }
    }
    render() {
        let { operatordata } = this.state
        if (!operatordata) {
            return null;
        }
        let showMoreStr;
        let newoperatordata = []
        let showMore = this.state.showMore;
        for (var obj in operatordata) {
            let o = {};
            o[obj] = operatordata[obj];
            newoperatordata.push(o)
        }
        if (newoperatordata.length > 6) {
            showMoreStr = (showMore ?
                (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, '')}>收起<Icon type="up-circle" /></Button>)
                :
                (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, 'more')}>展开<Icon type="down-circle" /></Button>)
            );
        }
        else { showMoreStr = (<span style={{ paddingLeft: 5 }}></span>); }
        const items = [];
        newoperatordata.forEach((item, index) => {
            for (var obj in item) {
                if(item[obj] != "substring" && item[obj] != "ifelse"){
                    if (this.state.showMore) {
                        items.push(<Tag key={obj} value={item[obj]} onClick={() => this.props.onClick(obj)}>{item[obj]}</Tag>);
                    }
                    else {
                        if (index < 6) {
                            items.push(<Tag key={obj} value={item[obj]} onClick={() => this.props.onClick(obj)}>{item[obj]}</Tag>);
                        }
                    }
                }
            }
        });
        return (
            <div>{items}{showMoreStr}</div>
        );
    }
}
//比较符
class Comparemark extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comparemarkdata: [],
            defaultdata: []
        }
    }
    componentDidMount() {
        this.getEnumList()
    }
    //获取比较符数据
    async  getEnumList() {
        const config = {
            url: 'enum/getEnumMap',
            method: 'GET',
            params: {
                enumtype: 'compareLogic'
            }
        };
        const json = await proxy(config);
        if (json.code !== 200) return;
        json.data && this.setState({ comparemarkdata: json.data })
    }
    render() {
        let { comparemarkdata } = this.state;
        const options = [];
        let defaultselect = null;
        const Option = Select.Option;
        if (!comparemarkdata) {
            return null;
        }
        if (!this.props.selectvalue) {
            defaultselect = undefined;
        }
        else {
            defaultselect = comparemarkdata[this.props.selectvalue];
        }
        for (var obj in comparemarkdata) {
            let item = (<Option key={obj}>{comparemarkdata[obj]}</Option>)
            options.push(item);
        }
        return <Select value={defaultselect} placeholder="请选择" onChange={(value) => this.props.onChange(value)}>{options}</Select>
    }
}
//参照ID
class ReferInput extends Component {
    constructor(props) {
        super(props);
        let name = ''
        if (this.props.editreferid) {
            name = this.props.editreferid
        }
        //构建参照模型
        this.referModel = new cb.models.ReferModel({ cRefType: 'pub_refList', refReturn: 'code', value: name, displayname: 'name' });
    }
    componentDidMount() {
        let self = this;
        let codeValue = ""
        this.referModel.on('afterValueChange', function () {
            codeValue = this.getValue()
            self.props.getValue(codeValue)
        })
    }
    render() {
        return (<Refer model={this.referModel} />)
    }
}
//自定义项类型
class ReferStyle extends Component {
    constructor(props) {
        super(props);
        let styleName = '';
        let displayName = ""
        if (this.props.editvalue) {
            styleName = this.props.editvalue
        }
        let type = this.props.copycodeId ? this.props.copycodeId : "";
        displayName = type.indexOf("pc_userdefclassref") != -1 ? 'showItem' : 'name'

        //构建参照模型
        this.referModel = new cb.models.ReferModel({ cRefType: type, refReturn: 'defineId', value: styleName, displayname:displayName , multiple: false });
    }
    componentDidMount() {
        let self = this;
        let arrayCode = "";
        let codeValue = "";
        let newname = this.props.editvalue;
        let referValue = this.referModel.getValue();
        this.referModel.on('afterValueChange', function () {
            codeValue = this.getValue()
            if(Array.isArray(codeValue)){
                codeValue.forEach((ele,index) => {
                  if(index == (codeValue.length-1)){
                    arrayCode = arrayCode + ele
                  }
                  else{
                    arrayCode = arrayCode + ele + ","
                  }
                })
              }
              arrayCode ? self.props.getReferStyle(arrayCode) : self.props.getReferStyle(codeValue)
        })
        this.referModel.browse(false, function (vm) {
            vm.on('getRefMetaReady', function () {
                if (!referValue) {
                    if (referValue === null)
                        this.referModel.setValue(referValue);
                    return;
                }
                var condition = {
                    'isExtend': true,
                    simpleVOs: [{ field: 'defineId', op: 'eq', value1: newname }]
                };
                vm.execute('pressEnter', { model: this.referModel, condition, browse: false });
            });
        });
    }
    render() {
        return (<Refer model={this.referModel} />)
    }
}
//参照返回字段
class Selectrefercode extends Component {
    render() {
        let returnvalue = this.props.returnvalue;
        const options = [];
        const Option = Select.Option;
        if (!returnvalue) {
            return null;
        }
        returnvalue.forEach(function (ele) {
            let referitem = (<Option key={ele.cName}>{ele.cShowCaption}</Option>)
            options.push(referitem)
        })
        return (<Select value={this.props.defaultrefer} onChange={(value) => this.props.selectrefer(value)}>{options}</Select>)
    }
}
//参照单选or多选
class IsMultiple extends Component {
    render() {
        return (
            <div className='refer_selectmode'>
                <Radio.Group onChange={this.props.onRadioChange} value={this.props.selectMode}>
                    <Radio value={0}>单选</Radio>
                    <Radio value={1}>多选</Radio>
                </Radio.Group>
            </div>
        )
    }
}
//过滤类型
class FilterType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterTypedata: [],
            defaultfilter: []
        }
    }
    componentDidMount() {
        this.getFiltertypeList()
    }
    //获取过滤类型数据
    async  getFiltertypeList() {
        const config = {
            url: 'enum/getEnumMap',
            method: 'GET',
            params: {
                enumtype: 'aa_itemtype'
            }
        };
        const json = await proxy(config);
        if (json.code !== 200) return
        json.data && this.setState({ filterTypedata: json.data })
    }
    render() {
        let { filterTypedata } = this.state;
        const options = [];
        const Option = Select.Option;
        let defaultselecttype = null;
        if (!filterTypedata) {
            return null;
        }
        if (!this.props.selectfilter) {
            defaultselecttype = undefined;
        }
        else {
            defaultselecttype = filterTypedata[this.props.selectfilter]
        }
        for (var obj in filterTypedata) {
            let item = (<Option key={obj}>{filterTypedata[obj]}</Option>)
            options.push(item)
        }
        return <Select value={defaultselecttype} placeholder="请选择" onChange={(value) => this.props.onChange(value)}>{options}</Select>
    }
}
//枚举
class Enumeration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enudata: [],
            selectenu: "selectenu"
        }
    }
    componentDidMount() {
        this.getdataSource()
    }
    //获取枚举数据
    async getdataSource() {
        const config = {
            url: 'filterDesign/getEnumList',
            method: 'GET',
        };
        const json = await proxy(config);
        if (json.code !== 200) return
        json.data && this.setState({ enudata: json.data })
    }
    render() {
        let showtreenodes = [];
        let { enudata } = this.state;
        let enuvalue = null;
        if (!this.props.value) {
            enuvalue = undefined;
        }
        else {
            enuvalue = this.props.value
        }
        const TreeNode = TreeSelect.TreeNode;
        enudata.forEach(function (item, index) {
            let showtreenode = (<TreeNode className="enumtree" key={item.description} title={item.description} value={item.enumtype}></TreeNode>)
            showtreenodes.push(showtreenode)
        })
        return (
            <TreeSelect
                showSearch
                style={{ width: 300 }}
                value={enuvalue}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择"
                allowClear
                treeDefaultExpandAll
                onChange={(value) => this.props.enuonchang(value)}
            >
                {showtreenodes}
            </TreeSelect>
        );
    }
}
//左边日期
class PickerDemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 'default',
        }
    }
    render() {
        return (
            <DatePicker value={this.props.pickerdate} format={format} onChange={(date, dateString) => this.props.onPickerday(date, dateString)} />
        )
    }
}
//右边日期
class PickerDemo2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 'default',
        }
    }
    render() {
        return (
            <DatePicker value={this.props.pickerdate2} format={format} onChange={(date, dateString) => this.props.onPickerday2(date, dateString)} />
        )
    }
}
//新增、编辑自定义过滤项
export default class addDefineditem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            billno: this.props.model.getParams().billNo,
            nameErrInfo: null,
            enuErrInfo: null,
            contextErrInfo: null,
            codeIdErrInfo: null,
            styleCodeErrInfo:null,
            returnErrInfo: null,
            filtertypeErrInfo: null,
            compareErrInfo: null,
            filterName: '' || this.props.editdata && this.props.editdata.itemTitle,
            visible: true,
            errorInfo: '',
            operatorValue: '' || this.props.editdata && this.props.editdata.itemNameDesc,
            isShow: false,
            isEnum: false,
            ispicker: false,
            isinputnum: false,
            selectvalue: '' || this.props.editdata && this.props.editdata.compareLogic,
            selectfilter: '' || this.props.editdata && this.props.editdata.itemType,
            selectionStart: 0,
            checkState: false,
            enuchangevalue: '' || this.props.editdata && this.props.editdata.cEnumType,
            checkPass: false,
            returnvalue: [],
            defaultrefer: '' || this.props.editdata && this.props.editdata.refReturn,
            codeId: '',
            styleCodeId:'',
            isedit: false,
            textvalue: '' || this.props.editdata && this.props.editdata.defaultVal1,
            isinputarea: false,
            numvalue: null || this.props.editdata && this.props.editdata.defaultVal1,
            pickerdate: null || this.props.editdata && this.props.editdata.defaultVal1 && moment(this.props.editdata.defaultVal1, 'YYYY-MM-DD HH:mm:ss'),
            pickerdate2: null || this.props.editdata && this.props.editdata.defaultVal2 && moment(this.props.editdata.defaultVal2, 'YYYY-MM-DD HH:mm:ss'),
            checkvalue:'',
            hovered: false,
            selectMode: 0 || this.props.editdata && this.props.editdata.multSelect
        }
    }
    componentDidMount() {
        if (this.props.editdata) {
            if (this.props.editdata.itemType) {
                this.changeFiltertype(this.props.editdata.itemType)
                this.setState({ isedit: true, checkState: true })
            }
            if(this.props.editdata.referCode){
                let cSelfDefineType = this.props.editdata.cSelfDefineType ? this.props.editdata.cSelfDefineType : ""
                this.getValue(this.props.editdata.referCode)
                this.getReferStyle(cSelfDefineType)
            }
            
        }
        else return;
    }
    //关闭模态框
    onclose() {
        this.setState({ nameErrInfo: null, enuErrInfo: null, contextErrInfo: null, checkPass: false, codeIdErrInfo: null, filtertypeErrInfo: null, compareErrInfo: null, returnErrInfo: null,styleCodeErrInfo:null })
        this.props.closeadd()
    }
    //获取左边选中的选项
    onSelect(conditionDesc, selectionStart) {
        let self = this;
        let checkState = conditionDesc ? true : false
        self.setState({ operatorValue: conditionDesc, selectionStart, checkState, checkPass:false })
    }
    getControl(control, caption, required) {
        const title = required ? <label><Icon type='star' />{caption}</label> : <label>{caption}</label>;
        return (
            <Label control={control} title={title} className="rightcontent_item" />
        );
    }
    //自定义过滤项名称
    onNameChange(e) {
        this.setState({ filterName: e.target.value })
    }
    //文本值更改
    ontextvalueChange(e) {
        this.setState({ textvalue: e.target.value })
    }
    //数值更改
    onNuminputChange(e) {
        this.setState({ numvalue: e })
    }
    //运算符判断
    handleOperatorSelect(e) {
        let { operatorValue, selectionStart } = this.state;
        if (operatorValue == undefined) {
            operatorValue = ''
        }
        const leftExp = operatorValue.substr(0, selectionStart);
        const rightExp = operatorValue.substr(selectionStart);
        operatorValue = leftExp + e + rightExp
        selectionStart = operatorValue.length;
        let checkState = operatorValue ? true : false;
        this.setState({ operatorValue, selectionStart, checkState, checkPass:false })
    }
    //过滤表达式值更改
    onChangearea(e) {
        let checkState = e.target.value ? true : false
        this.setState({ operatorValue: e.target.value, selectionStart: e.target.selectionStart, checkState: checkState, checkPass:false })
    }
    //比较符更改
    handChange(value) {
        let {selectfilter,textvalue,numvalue} = this.state;
        if(selectfilter == 'Input' && (value == 'is_null'||value == 'is_not_null')){textvalue = 'null'}
        else{textvalue =  ''}
        if(selectfilter == 'inputnumber' && (value == 'is_null'||value == 'is_not_null')){numvalue = 0}
        else{numvalue = null}
        this.setState({ selectvalue: value,textvalue ,numvalue})
    }
    //过滤类型更改
    changeFiltertype(value) {
        let {selectvalue,textvalue,numvalue} = this.state;
        if(value == 'Input' && (selectvalue == 'is_null'||selectvalue == 'is_not_null')){textvalue?'null':textvalue}
        if(value == 'inputnumber' && (selectvalue == 'is_null'||selectvalue == 'is_not_null')){numvalue?numvalue:0}
        switch (value) {
            case 'DatePicker':
                this.setState({ ispicker: true, isinputarea: false, isShow: false, isEnum: false, isinputnum: false,selectfilter: value,codeId:'' })
                break;
            case 'Input':
                this.setState({ isinputarea: true, isShow: false, isEnum: false, isinputnum: false, ispicker: false,selectfilter: value,codeId:'' })
                break;
            case 'Refer':
                this.setState({ isShow: true, isEnum: false, isinputarea: false, isinputnum: false, ispicker: false,selectfilter: value,codeId:'' })
                break;
            case 'Select':
                this.setState({ isEnum: true, isShow: false, isinputarea: false, isinputnum: false, ispicker: false,selectfilter: value,codeId:'' })
                break;
            case 'inputnumber':
                this.setState({ isinputnum: true, isShow: false, isEnum: false, isinputarea: false, ispicker: false,selectfilter: value,codeId:'' })
                break;
        }
        this.setState({ selectfilter: value,textvalue,numvalue })
    }
    getValue(value) {
        if(value == null){
            this.setState({returnvalue:[],defaultrefer:'',codeId: value})
        }
        else{
            this.getreferdata(value)
            this.setState({ codeId: value })
        }
    }
    getReferStyle(value){
        this.setState({styleCodeId:value})
    }
    //根据选中参照请求数据
    async getreferdata(value) {
        const config = {
            url: 'filterDesign/getRefRetList',
            method: 'GET',
            params: { refCode: value }
        };
        const json = await proxy(config);
        if (json.code !== 200) return;
        json.data && this.setState({ returnvalue: json.data })
    }
    //参照字段值更改
    selectrefer(changevalue) {
        this.setState({ defaultrefer: changevalue })
    }
    //枚举值更改
    enuonchang(value) {
        this.setState({ enuchangevalue: value })
    }
    //参照选择方式更改
    radioChange = (e) => {
        this.setState({
            selectMode: e.target.value
        })
    }    
    //左边日期值更改
    onPickerdata = (date, dateString) => {
        let self = this;
        self.setState({ pickerdate: date })
    }
    //右边日期值更改
    onPickerdata2 = (date, dateString) => {
        let self = this;
        self.setState({ pickerdate2: date })
    }
    getFilterControl() {
        const { TextArea } = Input;
        const classname = 'error_info';
        let referName = ""
        let { filterName, errorInfo, operatorValue, isShow, selectvalue, selectfilter, isEnum, enuchangevalue, textvalue, isinputarea, numvalue, isinputnum, ispicker, pickerdate, pickerdate2,hovered,codeId,styleCodeId } = this.state;
        
        let isShowstyle = false;
        if (codeId != null) {
            isShowstyle =( codeId.indexOf("pc_userdefclassref") != -1 || codeId.indexOf("productcenter.pc_userdefref") != -1) ? true : false;
            referName =  codeId.indexOf("pc_userdefclassref") != -1  ? "参照类型" : "参照值"
        }
        let content = <div className="tips_content">
                  <p className="tips_title"><strong>过滤表达式说明:</strong></p>
                  <div className="tips_infomation">
                  <p className="tips_item">1、数值类型的字段支持进行四则运算、比较运算、逻辑运算，可组成简单的四则运算表达式、关系表达式、逻辑表达式。</p>
                  <p className="tips_item">2、文本、日期、枚举、档案类型字段不支持进行四则运算、比较运算（=、!=除外）。因此这些类型字段一般都是选取字段本身作为表达式，或者组成等式表达式或简单逻辑表达式。</p>
                   <p className="tips_item">3、逻辑表达式仅支持由“=、!=”构成的等式表达式之间的逻辑运算，例如：</p>
                   <p className="tips_item tips_item2">· and运算符（&&：[规格型号]!=null&&[物料简称]!=null</p>
                   <p className="tips_item tips_item2">· or运算符（||）：[规格型号]!=null||[物料简称]!=null</p>
                   <p className="tips_item tips_item2">· not运算符（!）：[规格型号]!=null</p>
                   <p className="tips_item">4、示例：各类型字段的过滤表达式示例如下：</p>
                  <p className="tips_item tips_item2">· 文本类型字段：[客户名称]、[物料详情.物料简称]=[物料名称]</p>
                   <p className="tips_item tips_item2">· 日期类型字段：[成立时间]</p>
                   <p className="tips_item tips_item2">· 档案类型字段：[客户分类.分类名称]</p>
                   <p className="tips_item tips_item2">· 枚举类型字段：[是否散户]</p>
                  <p className="tips_item tips_item2">· 数值类型字段：[注册资金]*1000、[物料详情.线上零售价]*[物料详情.商城-线上库存量]</p>
                   <p className="tips_item">5、点击【校验】按钮，系统按SQL-where子句的语法来校验“过滤表达式”的语法正确性，如存在语法错误校验不通过。</p>
                  </div>
                    </div>
        const addDefinedName = <Input className={this.state.nameErrInfo ? classname : null} value={filterName} placeholder="请输入" onChange={(e) => this.onNameChange(e)} />
        const operatorCom = <Operator onClick={(e) => this.handleOperatorSelect(e)} />
        const addDefinedCondition = <TextArea className={(errorInfo ? classname : 'filter_inputArea') && (this.state.contextErrInfo ? classname : null)} rows={3} onChange={(e) => this.onChangearea(e)} value={operatorValue} />
        const inputtaxt = <TextArea value={textvalue} onChange={(e) => this.ontextvalueChange(e)}></TextArea>
        const inputnum = <InputNumber value={numvalue} onChange={(e) => this.onNuminputChange(e)}></InputNumber>
        const compareMark = <Comparemark onChange={(value) => this.handChange(value)} selectvalue={selectvalue}></Comparemark>
        const filterType = <FilterType onChange={(value) => this.changeFiltertype(value)} selectfilter={selectfilter}></FilterType>
        const referInput = <ReferInput model={this.fromModel} getValue={(value) => this.getValue(value)} editreferid={this.props.editdata.refCodeName}></ReferInput>
        const referStyle = <ReferStyle model={this.fromModel} getReferStyle={(value) => this.getReferStyle(value)} copycodeId={codeId} editvalue={this.props.editdata.cSelfDefineType}></ReferStyle>
        const pickerselect = <PickerDemo onPickerday={(date, dateString) => this.onPickerdata(date, dateString)} pickerdate={pickerdate}></PickerDemo>
        const pickerselect2 = <PickerDemo2 onPickerday2={(date, dateString) => this.onPickerdata2(date, dateString)} pickerdate2={pickerdate2}></PickerDemo2>
        const selectrefercode = <Selectrefercode returnvalue={this.state.returnvalue} selectrefer={(changevalue) => this.selectrefer(changevalue)} defaultrefer={this.state.defaultrefer}></Selectrefercode>
        const enumeration = <Enumeration enuonchang={(value) => this.enuonchang(value)} value={enuchangevalue} className={this.state.enuErrInfo ? classname : null}></Enumeration>
        const isMultiple = <IsMultiple onRadioChange={this.radioChange} selectMode={this.state.selectMode}></IsMultiple>
        let referId = (isShow ? <div className="add_defined">
            {this.getControl(referInput, '参照ID', true)}
            {this.state.codeIdErrInfo ? <div className='error'>{this.state.codeIdErrInfo}</div> : null}
        </div> : null)
        let refertyle = (isShowstyle ? <div className="add_defined" >
             {this.getControl(referStyle, referName, true)}
             {this.state.styleCodeErrInfo ? <div className='error'>{this.state.styleCodeErrInfo}</div> :null}
        </div>:null)
        let refercode = (isShow ? <div className="add_defined">
            {this.getControl(selectrefercode, '参照返回字段', true)}
            {this.state.returnErrInfo ? <div className='error'>{this.state.returnErrInfo}</div> : null}
        </div> : null)
        let referIsMultiple = (isShow ? <div>
            {this.getControl(isMultiple, '参照选择方式', true)}
        </div> : null)
        let textarea = (isinputarea ? <div className="Input_text">{this.getControl(inputtaxt, '文本', false)}</div> : null)
        let numarea = (isinputnum ? <div className="Input_num">{this.getControl(inputnum, '数值', false)}</div> : null)
        let pickershow = (ispicker ? <div className={selectvalue == "between" ? "Input_picker2" : "Input_picker"}>
            {this.getControl(pickerselect, '日期', false)}
        </div> : null)
        let pickershow2 = (selectvalue == "between" && selectfilter == "DatePicker" ? <div className="Input_pickerdate">
            {this.getControl(pickerselect2, '至', false)}
        </div> : null)
        let showenumeration = (isEnum ? <div className="enumeration">
            {this.getControl(enumeration, '枚举项', true)}
            {this.state.enuErrInfo ? <label className="error">{this.state.enuErrInfo}</label> : null}
        </div> : null)
        return (
            <div>
                <div className="add_defined">
                    {this.getControl(addDefinedName, '过滤名称', true)}
                    {this.state.nameErrInfo ? <div className='error'>{this.state.nameErrInfo}</div> : null}
                </div>
                <div className="operatorCom">{this.getControl(operatorCom, '运算符')}</div>
                <div className='add_defined'>
                    {this.getControl(addDefinedCondition, '过滤表达式', true)}
                   <div className="tips_popover">
                   <Popover placement="left" visible={hovered} content={content} trigger="hover" onVisibleChange={this.handleHoverChange} overlayClassName={'tips_style'}>
                       <Button className="tips_svg"><SvgIcon type={hovered?"wenhaolveguo":"wenhaomoren"}/></Button>
                       </Popover>
                    </div>
                    {errorInfo ? <label className="error">{errorInfo}</label> : null}
                    {this.state.contextErrInfo ? <div className='error'>{this.state.contextErrInfo}</div> : null}
                </div>
                <div className="add_defined">
                    {this.getControl(compareMark, '比较符', true)}
                    {this.state.compareErrInfo ? <div className='error'>{this.state.compareErrInfo}</div> : null}
                </div>
                <div className="add_defined">
                    {this.getControl(filterType, '过滤类型', true)}
                    {this.state.filtertypeErrInfo ? <div className='error'>{this.state.filtertypeErrInfo}</div> : null}
                </div>
                {referId}
                {refertyle}
                {refercode}
                {referIsMultiple}
                {showenumeration}
                {textarea}
                {numarea}
                {pickershow}
                {pickershow2}
            </div>
        )
    }
    //过滤表达式提示
    handleHoverChange = visible => {
        this.setState({
          hovered: visible,
        });
      };
    changeNameErrInfo = (text) => {
        this.setState({ nameErrInfo: text })
    }
    changeContextErrInfo = (text) => {
        this.setState({ contextErrInfo: text })
    }
    changeEnuErrInfo = (text) => {
        this.setState({ enuErrInfo: text })
    }
    changeCodeIdErrInfo = (text) => {
        this.setState({ codeIdErrInfo: text })
    }
    changeStyleCodeErrInfo = (text) => {
        this.setState({ styleCodeErrInfo: text })
    }
    changecompareErrInfo = (text) => {
        this.setState({ compareErrInfo: text })
    }
    changefiltertypeErrInfo = (text) => {
        this.setState({ filtertypeErrInfo: text })
    }
    changereturnErrInfo = (text) => {
        this.setState({ returnErrInfo: text })
    }
    handcheck = () => {
        let { operatorValue, billno } = this.state;
        this.sethandcheck(operatorValue, billno)
    }
    async sethandcheck(operatorValue, billNo) {
        const config = {
            url: 'filterDesign/checkCondition',
            method: 'POST',
            params: {
                billno: billNo,
                expression: operatorValue
            }
        };
        const json = await proxy(config);
        if (json.code !== 200) {
            this.setState({ errorInfo: json.message, contextErrInfo: null, checkPass: false })
        }
        else {
            cb.utils.alert('校验成功', 'success');
            this.setState({ errorInfo: '', contextErrInfo: null, checkPass: true, checkvalue: json.data })
        }
    }
    //保存
    handlesave = () => {
        let { selectMode, operatorValue, filterName, selectvalue, selectfilter, defaultrefer, codeId, enuchangevalue, textvalue, numvalue, pickerdate, pickerdate2 ,checkvalue,styleCodeId} = this.state
        let filtersId = this.props.filtersId
        let Id = null;
        if (this.props.editdata && this.props.editdata.id) {
            Id = this.props.editdata.id
        }
        else {
            Id = null
        }
        if (typeof (filtersId) == 'string') {
            filtersId = parseInt(filtersId)
        }
        let savedata = {
            "filtersId": filtersId,
            "itemTitle": filterName,
            "precision": 0,
            "dataSource": checkvalue,
            "itemNameDesc": operatorValue,
            "compareLogic": selectvalue,
            "mustInput": 0,
            "cShowCaption": filterName,
            "isSys": 0,
            "id": Id,
        }
        if (selectfilter == "inputnumber") {
            let numput = { "defaultVal1": numvalue, "itemType": selectfilter, "bEnum": false, }
            savedata = Object.assign(savedata, numput)
        }
        if (selectfilter == "Refer") {
            let refer1 = {
                "referCode": codeId,
                "refReturn": defaultrefer,
                "itemType": 'Refer',
                "bEnum": false,
                "cSelfDefineType": styleCodeId,
                "multSelect": selectMode
            };
            let refer2 = {
                "referCode": codeId,
                "refReturn": defaultrefer,
                "itemType": 'Refer',
                "bEnum": false,
                "multSelect": selectMode
            };
            let newStyleCodeId = refer2;
            if (codeId != null) {
                newStyleCodeId = ( codeId.indexOf("pc_userdefclassref") != -1 || codeId.indexOf("productcenter.pc_userdefref") != -1) ? refer1 : refer2
            }
            savedata = Object.assign(savedata, newStyleCodeId)
        }
        if (selectfilter == "Input") {
            let defaultstyle = { "defaultVal1": textvalue, "itemType": selectfilter, "bEnum": false, }
            savedata = Object.assign(savedata, defaultstyle)
        }
        if (selectfilter == "Select") {
            let saveenum = {
                "cEnumType": enuchangevalue,
                "itemType": 'Select',
                "bEnum": true,
             }
            savedata = Object.assign(savedata, saveenum)
        }
        if (selectfilter == "DatePicker") {
            let savepicker = {};
            if (selectvalue == "between") {
                savepicker = {
                    "defaultVal1": pickerdate && moment(pickerdate).format(format) + ' ' + '00:00:00',
                    "defaultVal2": pickerdate2 && moment(pickerdate2).format(format) + ' ' + '23:59:59',
                    "itemType": selectfilter,
                    "bEnum": false,
                }
            }
            else {
                savepicker = {
                    "defaultVal1": pickerdate && moment(pickerdate).format(format) + ' ' + '00:00:00',
                    "itemType": selectfilter,
                    "bEnum": false,
                }
            }
            savedata = Object.assign(savedata, savepicker)
        }
        this.savedefinedfilter(savedata)
    }
    async savedefinedfilter(savedata) {
        const config = {
            url: 'filterDesign/saveCustMetaFilterItem',
            method: 'POST',
            params: savedata
        };
        const json = await proxy(config);
        if (json.code !== 200) {
            cb.utils.alert('保存失败' + json.message, 'error')
        }
        else {
            cb.utils.alert('保存成功', 'success');
            this.props.closeadd();
            this.props.showGrid(this.props.filtersId)
            this.props.regetquery(this.props.modelId, this.props.filtersId)
        }
    }
    render() {
        return (
            <div className="adddefined_modal">
                <Modal title={this.state.isedit ? "编辑过滤项" : "新增过滤项"} visible={this.state.visible} className="addfilter_content" width={820} mask={false}
                    onCancel={() => this.onclose()} maskClosable={false}
                    footer={<Filterfooter
                        onsave={this.handlesave}
                        handleclose={() => this.onclose()}
                        checkPass={this.state.checkPass}
                        filterName={this.state.filterName}
                        operatorValue={this.state.operatorValue}
                        enuchangevalue={this.state.enuchangevalue}
                        selectvalue={this.state.selectvalue}
                        selectfilter={this.state.selectfilter}
                        codeId={this.state.codeId}
                        styleCodeId = {this.state.styleCodeId}
                        defaultrefer={this.state.defaultrefer}
                        checkitem={this.handcheck}
                        checkState={this.state.checkState}
                        onNameErrInfoChange={this.changeNameErrInfo}
                        onContextErrInfoChange={this.changeContextErrInfo}
                        onEnuErrInfoChange={this.changeEnuErrInfo}
                        onCodeIdErrInfoChange={this.changeCodeIdErrInfo}
                        onStylecodeErrInfoChange={this.changeStyleCodeErrInfo}
                        oncompareErrInfoChange={this.changecompareErrInfo}
                        onfilterErrIfoChange={this.changefiltertypeErrInfo}
                        onReturnErrInfoChang={this.changereturnErrInfo}
/>}>
                    <div style={{ height: 480 }}>
                        <div className="LeftContent" style={{ width: 232, float: 'left', height: 494, overflowy: 'auto', marginRight: 26 }}>
                            <DefinedLeftcontent onSelect={(conditionDesc, selectionStart) => this.onSelect(conditionDesc, selectionStart)} model={this.props.model} selectionStart={this.state.selectionStart} operatorValue={this.state.operatorValue} />
                        </div>
                        <div className="RightContent" style={{ width: 514, float: ' left', marginleft: 34, paddingtop: 20, height: 494, overflowy: 'auto' }}>
                            {this.getFilterControl()}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/addDefineditem.jsx